<template>
  <footer class="app-footer">
    <span >Powered by <a href="https://infia.co.id" target="_blank">Infia</a> &copy; 2018</span>
  </footer>
</template>
<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue